import moment from 'moment'
import { DATE_FIELD } from '../type_name'
const invalidValue = [ undefined, null, '']
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: DATE_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        }
    },
    computed: {
        valueHandle() {
            if (invalidValue.includes(this.value) && !invalidValue.includes(this.header.default_value)) {
                return this.header.default_value
            }
            if (invalidValue.includes(this.value) && invalidValue.includes(this.header.default_value)) {
                return '-'
            }
           
            return moment(this.value).format(this.header.format || 'YYYY-MM-DD')
        }
    },
    render() {
        return <span>{this.valueHandle}</span> 
        
    }
}